import { Component } from '@angular/core';

@Component({
  selector: 'app-store-dashboard',
  imports: [],
  templateUrl: './store-dashboard.component.html',
  styleUrl: './store-dashboard.component.scss'
})
export class StoreDashboardComponent {

}
